import { useDispatch, useSelector } from 'react-redux';
import { Table } from '@quintoandar-tokko/jopijs';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import parentStyles from '../dashboardTables.module.scss';
import specificStyles from './agentsPerformanceTable.module.scss';
import HeaderCell from '../components/HeaderCell';
import { TABLE_SORT_FIELDS } from '../../constants';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import AgentsPerformanceGroupedTableContent from './AgentsPerformanceGroupedTableContent';
import AgentsPerformanceNonGroupedTableContent from './AgentsPerformanceNonGroupedTableContent';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';
import LoadingMoreSkeleton from '../components/LoadingMoreSkeleton';

export default function AgentsPerformanceTable() {
  const dispatch = useDispatch();
  const { agentsPerformance } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const track = useTrackPerformanceTable();

  const headers = [
    {
      id: 1,
      title: Trans(translations, 'Agent'),
      subtitle: Trans(translations, 'Branch'),
      field: TABLE_SORT_FIELDS.AGENT_NAME,
    },
    {
      id: 2,
      title: Trans(translations, 'AssignedContacts'),
      field: TABLE_SORT_FIELDS.ASSIGNED_CONTACTS,
    },
    {
      id: 3,
      title: Trans(translations, 'SavedSearches'),
      field: TABLE_SORT_FIELDS.SAVED_SEARCHES,
    },
    {
      id: 4,
      title: Trans(translations, 'SharedFiles'),
      field: TABLE_SORT_FIELDS.SHARED_FILES,
    },
    {
      id: 5,
      title: Trans(translations, 'Events'),
      field: TABLE_SORT_FIELDS.EVENTS,
    },
    {
      id: 6,
      title: Trans(translations, 'ConcretedOperations'),
      field: TABLE_SORT_FIELDS.COMPLETED_OPERATIONS,
    },
  ];

  const handleCellClick = (header) => {
    if (!header.field) return;
    dispatch(
      setPerformanceModals({
        key: 'agentsPerformance',
        subkey: 'sortBy',
        value: header.field,
      })
    );
    if (track.agentsPerformance)
      track.agentsPerformance(TRACK_ELEMENT.COLUMN_ORDER);
  };

  return (
    <Table
      id="agents-performance-table"
      className={`${parentStyles.table} ${specificStyles.agentsPerformanceTable}`}
    >
      <Table.Header className={parentStyles.tableHeader}>
        {headers.map((header) => (
          <HeaderCell
            key={header.id}
            id={header.id}
            title={header.title}
            subtitle={header.subtitle}
            field={header.field}
            sortBy={agentsPerformance.sortBy}
            sortDirection={agentsPerformance.sortDirection}
            onClick={() => handleCellClick(header)}
          />
        ))}
      </Table.Header>

      {!agentsPerformance.loading &&
        (agentsPerformance.groupByBranch ? (
          <AgentsPerformanceGroupedTableContent />
        ) : (
          <AgentsPerformanceNonGroupedTableContent />
        ))}

      {agentsPerformance.loading && (
        <LoadingMoreSkeleton columns={headers.length} rows={7} />
      )}
    </Table>
  );
}
